import { useContext } from 'react';
import { ApiContext } from './api-context';

export function useApiCredentials() {
  const context = useContext(ApiContext);

  if (!context) {
    throw new Error('Api context is not provided');
  }
  const { hasToken, getToken, setToken, isTokenExpired, refreshToken } =
    context;

  return {
    getToken,
    setToken,
    hasToken,
    isTokenExpired,
    refreshToken,
  };
}
